<template>
    <a-modal v-bind:open="computedShowModal"
        width="600px"
        :closable="true"
        :footer="null"
        :mask-closable="false"
        :mask-style="{backdropFilter: 'blur(2px)'}"
        :keyboard="false"
        title="계정 생성"
        :centered="true"
        @cancel="uiHandler.closeModal"
        :destroyOnClose="true"
    >
        <div class="modal-content-body">
            <a-form
                ref="formRef"
                :model="formState"
                :rules="rules"
                :label-col="labelCol"
                :wrapper-col="wrapperCol"
                label-align="left"
                style="display: flex; flex-direction: column; gap: 8px;"
            >
                <a-form-item :colon="false" ref="deptName" name="deptName">
                    <template #label>
                        <form-label
                            label-title="부서명"
                            :is-required="false"
                        />
                    </template>
                    <a-col >
                        <a-input v-model:value="formState.deptName"
                            placeholder="부서명을 입력해주세요"
                            @click="uiHandler.checkIsUpdated"
                        />
                    </a-col>
                </a-form-item>
                <a-form-item :colon="false" ref="duty" name="duty">
                    <template #label>
                        <form-label
                            label-title="직급"
                            :is-required="false"
                        />
                    </template>
                    <a-col >
                        <a-input v-model:value="formState.duty"
                            placeholder="직급을 입력해주세요"
                        />
                    </a-col>
                </a-form-item>
                <a-form-item :colon="false" ref="name" name="name">
                    <template #label>
                        <form-label
                            label-title="이름"
                            :is-required="true"
                        />
                    </template>
                    <a-col >
                        <a-input v-model:value="formState.name"
                            placeholder="직원 이름을 입력해주세요"
                        />
                    </a-col>
                </a-form-item>
                <a-form-item :colon="false" ref="username" name="username" 
                :class="!isFirstTry ? 'no-margin-bottom' : ''"
                >
                    <template #label>
                        <form-label
                            label-title="아이디"
                            :is-required="true"
                        />
                    </template>
                    <a-col class="btn-right">
                        <div class="btn-right-row">
                            <a-input v-model:value="formState.username"
                                placeholder="아이디를 입력해주세요"
                                @change="uiHandler.resetDidCheck"
                                @keyup.enter="uiHandler.checkIsIdDuplicated"
                                class="black no-radius-right validate-btn"
                                :maxlength="30"
                                :readonly="readOnlyState.id"
                                @click="() => {readOnlyState.id = false}"
                                @focus="() => {readOnlyState.id = false}"
                            />
                            <a-button
                                class="black no-radius-left validate-btn"
                                @click="uiHandler.checkIsIdDuplicated"
                            >
                                중복 확인
                            </a-button>
                        </div>
                        <span 
                            v-if="isIdValidDisplay" class="success" style="margin-bottom: 0">
                            사용할 수 있는 아이디입니다.
                        </span>
                    </a-col>
                </a-form-item>
                <a-form-item :colon="false" ref="password" name="password" :maxlength="16">
                    <template #label>
                        <form-label
                            label-title="비밀번호"
                            :is-required="true"
                        />
                    </template>
                    <a-col >
                        <a-input-password 
                            v-model:value="formState.password" 
                            :maxlength="16"
                            placeholder="비밀번호를 입력해주세요(8~16자)"
                            :readonly="readOnlyState.password"
                            @click="() => {readOnlyState.password = false}"
                            @focus="() => {readOnlyState.id = false}"
                        />
                    </a-col>
                </a-form-item>
                <a-form-item :colon="false" ref="passwordConfirm" name="passwordConfirm">
                    <template #label>
                        <form-label
                            label-title="비밀번호 확인"
                            :is-required="true"
                        />
                    </template>
                    <a-col >
                        <a-input-password v-model:value="formState.passwordConfirm" :maxlength="16"
                            placeholder="비밀번호를 한 번 더 입력해주세요"
                        />
                    </a-col>
                </a-form-item>
                <a-form-item :colon="false" ref="mobile" name="mobile">
                    <template #label>
                        <form-label
                            label-title="휴대폰 번호"
                            :is-required="true"
                        />
                    </template>
                    <a-col >
                        <a-input v-model:value="formState.mobile"
                            :maxlength="13"
                            placeholder="휴대폰 번호를 입력해주세요"
                        />
                    </a-col>
                </a-form-item>
            </a-form>
        </div>
        <div class="create-acc-modal-footer">
        <a-button
            @click="uiHandler.closeModal"
        >
            취소
        </a-button>
        <a-button
            type="primary"
            @click="uiHandler.createManuAccount"
        >
            계정 생성
        </a-button>
        </div>
    </a-modal>
</template>
  
<script>
import { VueDraggableNext } from 'vue-draggable-next'
import FormLabel from "@/views/components/FormLabel.vue";
import enums from '@/utils/enums';
import {
    oneBtnDialog,
    convertYnToBool,
    boolToYn,
    deepCopy,
    phoneNumberFormatter,
} from '@/utils/utils';
import { modalType } from '../enums/enums';

const { YnEnum } = enums();

export default {
    name: 'CreateModal',
    components: {
        draggable: VueDraggableNext,
        FormLabel,
    },
    props: {
        showModal: {
        type: Boolean,
        required: true,
        default: false,
        },
    },
    computed: {
        computedShowModal() {
        return this.showModal;
        },
        computedIsIdValid() {
            if(this.didCheck && this.isIdValid) return true;
        },
    },
    emits: ['closeModal', 'getAccountsList'],
    data() {
        const validationHandler = this.validation();
        
        return {
        uiHandler: this.ui(),
        apiHandler: this.api(),
        validationHandler,
        YnEnum,
        labelCol: {span: 5},
        wrapperCol: {offset: 2, span: 17},
        didCheck: false,
        isIdValid: false,
        role: 'MANUFACTURER',
        didRequest: false,
        isIdValidDisplay: false,
        isFirstTry: true,
        formState: {
            deptName: "",
            duty: "",
            name: "",
            username: "",
            mobile: "",
            password: "",
            passwordConfirm: "",
        },
        readOnlyState: {
            id: true,
            password: true,
        },
        rules: {
            deptName: [
                {
                    required: false,
                    message: '부서명을 입력해주세요.',
                    trigger: 'click',
                }
            ],
            duty: [
                {
                    required: false,
                    message: '직급을 입력해주세요.',
                    trigger: 'click',
                }
            ],
            name: [
                {
                    required: true,
                    message: '이름을 입력해주세요.',
                    trigger: 'click',
                }
            ],
            username: [
                {
                    required: true,
                    trigger: 'click',
                    validator: validationHandler.validateId,
                }
            ],
            mobile: [
                {
                    required: true,
                    trigger: 'click',
                    validator: validationHandler.validatePhoneNumber,
                }
            ],
            password: [
                {
                    required: true,
                    trigger: 'click',
                    validator: validationHandler.validatePassword,
                }
            ],
            passwordConfirm: [
                {
                    required: true,
                    trigger: 'click',
                    validator: validationHandler.validatePasswordConfirm,
                }
            ],
        },
        };
    },

    async mounted() {
    },
    watch: {
        showModal(newValue, oldValue) {
            if(newValue) {
            }
        },
        'formState.mobile': {
            handler: function (newVal, oldVal) {
                if(!newVal) return;
                const cleanVal = newVal.replace(/\D/g, '');

                // Maximum length check
                if (cleanVal.length > 11) {
                this.formState.mobile = oldVal;
                return;
                }
                this.formState.mobile = phoneNumberFormatter(cleanVal);
            },
            immediate: true,
            deep: true,
        },
    },
    methods: {
        ui() {
        return {
            checkIsUpdated: () => {
                console.log('Y')
            },
            initModal: () => {
                this.didCheck = false;
                this.isIdValid = false;
                this.isIdValidDisplay = false;
                this.isFirstTry = true;
                this.formState = {
                    deptName: "",
                    duty: "",
                    name: "",
                    username: "",
                    mobile: "",
                    password: "",
                    passwordConfirm: "",
                };
            },
            closeModal: () => {
                this.$emit('closeModal', modalType.create, false);
                this.$emit('getAccountsList');
                this.uiHandler.initModal();
            },
            resetDidCheck: async (input) => {
                this.didCheck = false;
                this.isIdValid = false;
            },
            checkIsIdDuplicated: async () => {
                try {
                    const response = await this.apiHandler.checkIsIdDuplicated(this.formState.username);
                    this.didCheck = true;
                    if(response.data === true) {
                        this.isIdValid = false;
                        setTimeout(() => {
                            this.isIdValidDisplay = false;
                        }, 100)
                    } else {
                        this.isIdValid = true;
                        setTimeout(() => {
                            this.isIdValidDisplay = true;
                        }, 200)
                    }
                } catch(error) {
                    console.log(error);
                    await oneBtnDialog(this.$i18n.t('hospitalw_message_manager_invalid_title'),this.$i18n.t('hospitalw_message_manager_invalid_content'), false);
                } finally {
                    this.$refs.formRef.validateFields(['username']);
                    setTimeout(() => {
                        console.log(this.isFirstTry, this.isIdValid, this.isIdValidDisplay)
                    }, 200)
                }
            },
            createManuAccount: async () => {
                this.$refs.formRef.validateFields(['username']);
                this.$refs.formRef.validate().then(async () => {
                    try {
                        if(this.didRequest) return;
                        this.didRequest = true;
                        const obj = {
                            username: this.formState.username,
                            password: this.formState.password,
                            name: this.formState.name,
                            deptName: this.formState.deptName,
                            duty: this.formState.duty,
                            mobile: this.formState.mobile,
                            role: this.role,
                        };

                        const result = await this.apiHandler.createManuAccount(obj);
                        if(result.status !== 200 && result.status !== 201) throw new Error();
                        await oneBtnDialog('계정 생성 성공', '계정을 생성하였습니다.', false);
                        this.uiHandler.closeModal();
                    } catch(error) {
                        console.log(error);
                        await oneBtnDialog('계정 생성 실패', '계정 생성에 실패하였습니다.', false);
                    } finally {
                        this.didRequest = false;
                    }

                    
                }).catch(async error => {
                    console.error('error', error);
                })
            },
        }
        },
        validation() {
            return {
                validateId: (_rule, value) => {
                    this.isFirstTry = false;
                    let text = '';
                    if (!value) {
                        text = this.$i18n.t('hospitalw_message_manager_id_err_content');
                        this.isIdValid = false;
                        setTimeout(() => {
                            this.isIdValidDisplay = false;
                        }, 200)
                        return Promise.reject(new Error(text));
                    } 
                    if(!/^[a-zA-Z0-9_]*$/.test(value)) {
                        text = this.$i18n.t('manu_acc_id_rule_err');
                        this.isIdValid = false;
                        setTimeout(() => {
                            this.isIdValidDisplay = false;
                        }, 200)
                        return Promise.reject(new Error(text));
                    } 
                    if(value && !this.didCheck) {
                        text = this.$i18n.t('hospitalw_message_manager_id_valid_err_content');
                        this.isIdValid = false;
                        setTimeout(() => {
                            this.isIdValidDisplay = false;
                        }, 200)
                        return Promise.reject(new Error(text));
                    }
                    if(this.didCheck && !this.isIdValid) {
                        text = this.$i18n.t('hospitalw_message_manager_id_exist');
                        return Promise.reject(new Error(text));
                    }
                    
                    return Promise.resolve();
                },
                validatePhoneNumber: (_rule, value) => {
                    let text = '';
                    if (!value) {
                        text = '휴대폰 번호를 입력해 주세요.';
                        return Promise.reject(new Error(text))
                    } 
                    if(!value.startsWith('01') || value.length < 12) {
                        text = '휴대폰 번호를 올바르게 입력해 주세요.';
                        return Promise.reject(new Error(text))
                    } 
                    if(value.startsWith('010-0')) {
                        text = '휴대폰 번호를 올바르게 입력해 주세요.';
                        return Promise.reject(new Error(text))
                    }
                    if(value.startsWith('010') && value.length < 13) {
                        text = '휴대폰 번호를 올바르게 입력해 주세요.';
                        return Promise.reject(new Error(text))
                    }
                    return Promise.resolve();
                },
                validatePassword: (_rule, value) => {
                    let text = '';
                    const regexAlphabets = /[a-zA-Z]/;
                    const regexNumbers = /[0-9]/;

                    if (
                        value.length >= 8 &&
                        value.length <= 16 &&
                        regexAlphabets.test(value) &&
                        regexNumbers.test(value)
                    ) {
                        return Promise.resolve();
                    } 
                    if(!value) {
                        text = this.$i18n.t('hospitalw_message_pw_err_content');
                        return Promise.reject(new Error(text));
                    }
                    text = this.$i18n.t('hospitalw_message_pw_valid_err_content');
                    return Promise.reject(new Error(text));
                },
                validatePasswordConfirm: (_rule, value) => {
                    let text = '';
                    const regexAlphabets = /[a-zA-Z]/;
                    const regexNumbers = /[0-9]/;
                    if(!value) {
                        text = this.$i18n.t('hospitalw_message_pwconfirm_err_content');
                        return Promise.reject(new Error(text));
                    }
                    if(value !== this.formState.password) {
                        text = this.$i18n.t('hospitalw_message_pwnomatch_err_content');
                        return Promise.reject(new Error(text));
                    }
                    if (
                        value.length >= 8 &&
                        value.length <= 16 &&
                        regexAlphabets.test(value) &&
                        regexNumbers.test(value)
                    ) {
                        return Promise.resolve();
                    }
                    text = this.$i18n.t('hospitalw_message_pw_valid_err_content');
                    return Promise.reject(new Error(text));
                }
            }
        },
        api() {
            return {
                getDepts: async () => {
                    
                },
                checkIsIdDuplicated: async (username) => {
                    try {
                        if(!username) throw new Error('body 객체 없음');
                        const response = await this.$apiInstance.get(`/accounts/duplicateCheck/${username}`);
                        if (response.status !== 200 && response.status !== 201) throw new Error('state error');
                        return response;
                    } catch (error) {
                        console.log(error);
                        return error;
                    }
                },
                createManuAccount: async (obj) => {
                    try {
                        if(!obj) throw new Error('body 객체 없음');
                        const response = await this.$apiInstance.post(`/accounts`, obj);
                        if (response.status !== 200 && response.status !== 201) throw new Error('state error');
                        return response;
                    } catch (error) {
                        console.log(error);
                        return error;
                    }
                },
            }
        },
    },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/manu-account.scss';



@media screen and (max-width:767px) {
    .row{
        padding: 14px 14px 36px 14px !important
    }
    .item-btn-area{
        max-width: none;
    }
    p{
        margin-bottom: 0;
    }
}
@media screen and (min-width:768px) and (max-width:1023px){
    .w-35 {
        width: 50% !important;
    }
    p{
        margin-bottom: 0;
    }
}
</style>